import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enGlobal from './en';
import ptGlobal from './pt';
import { ptEmail, enEmail } from '@/modules/email/infra/i18n';

Vue.use(VueI18n);

const pt = { ...ptGlobal, ...ptEmail };

const en = { ...enGlobal, ...enEmail };

const messages = {
  en,
  pt,
};

const translate = (key) => {
  if (!key) {
    return '';
  }
  return i18n.t(key);
};

export { translate };

export default new VueI18n({
  locale: 'pt', // set locale
  messages, // set locale messages
});
